export default __webpack_public_path__ + "static/media/location_on_marker.e877f180.svg";